export enum LifeCycleKeys {
  IS_ENABLED = 'isEnabled',
  SKIPPABLE = 'skippable',
  CUSTOM_FREE_TRIAL = 'customFreeTrial',
  SUBSCRIPTION_CONFIGS = 'subscriptionStateConfigs',
}
